import React from 'react';
import { Skeleton } from '@mui/material';

const KpiCardSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col justify-between h-full gap-1.5">
      <div className="flex items-center gap-4 w-full">
        <Skeleton
          variant="circular"
          animation="wave"
          sx={{
            flexShrink: 0,
            width: 70,
            height: 70,
            backgroundColor: '#EDF3F6'
          }}
          className="max-lg-xl:w-15! max-lg-xl:h-15!"
        />
        <div className="w-full flex flex-col gap-3 max-lg-xl:gap-2">
          <div className="flex flex-col gap-3">
            <Skeleton
              variant="rounded"
              width={57}
              height={14}
              animation="wave"
              sx={{
                borderRadius: '50px',
                backgroundColor: '#EDF3F6'
              }}
            />
            <Skeleton
              variant="rounded"
              width={91}
              height={14}
              animation="wave"
              sx={{
                borderRadius: '50px',
                backgroundColor: '#EDF3F6'
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <Skeleton
          variant="rounded"
          width={100}
          height={14}
          animation="wave"
          sx={{
            borderRadius: '50px',
            backgroundColor: '#EDF3F6'
          }}
        />
      </div>

      <div>
        <Skeleton
          variant="rounded"
          width={46}
          height={14}
          animation="wave"
          sx={{
            borderRadius: '50px',
            backgroundColor: '#EDF3F6'
          }}
        />
      </div>
    </div>
  );
};

export default KpiCardSkeleton;
